import { render, staticRenderFns } from "./ListPayments.vue?vue&type=template&id=7d5ac480"
import script from "./ListPayments.vue?vue&type=script&lang=js"
export * from "./ListPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports